import { useEffect } from "react";
import { Button, Checkbox, Form, Radio, Flex } from "antd";

import {
  OPTIONS_PERMISSION,
  PERMISSION_DEFAULT_VALUE,
} from "../../../../../../constant";

const TabSuperAdmin = ({
  disableEdit,
  clientPermissions,
  handleSave,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      accessLevel: clientPermissions?.accessLevel ?? PERMISSION_DEFAULT_VALUE,
      manageSuperAdmins: clientPermissions?.manageProposals ?? true,
    });
  }, [clientPermissions]);

  return (
    <Form
      disabled={disableEdit}
      form={form}
      id="formPermissionsSuperAdmin"
      onFinish={handleSave}
    >
      <Flex className="container-permission">
        <h4>Super Admin Rights</h4>

        <Flex gap={44}>
          <Flex gap={16} vertical>
            <Flex
              gap={10}
              style={{
                background: "#F0F0F0",
                borderRadius: 12,
                padding: 16,
                width: 196,
              }}
              vertical
            >
              <b>Organizations *</b>
              <Form.Item name="accessLevel" style={{ margin: 0 }}>
                <Radio.Group options={OPTIONS_PERMISSION} />
              </Form.Item>
            </Flex>

            <div style={{ width: "fit-content" }}>
              <Form.Item
                colon={false}
                label="Manage Super Admins"
                labelCol={{ style: { marginLeft: 6, order: 2 } }}
                name="manageSuperAdmins"
                style={{ margin: 0 }}
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </div>
          </Flex>
        </Flex>

        <i style={{ color: "#4B4747", width: 300 }}>
          * Full access to organizations includes the ability for the Super
          Admin to manage all aspects of a client, including Enterprise Admins,
          Advisors and their clients.
        </i>
      </Flex>

      <div style={{ padding: "12px 32px" }}>
        <Button
          disabled={loading}
          htmlType="submit"
          shape="round"
          size="small"
          type="primary"
        >
          Apply Changes
        </Button>
      </div>
    </Form>
  );
};

export default TabSuperAdmin;
